<div class="car-list">
  <div class="page-header">
    <h1 class="page-title">Автомобили</h1>
  </div>

  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Поиск</mat-label>
    <input matInput
           placeholder="Введите название автомобиля или госномер"
           autocomplete="off"
           [value]="query()"
           (input)="onSearchInput($event)"
           [disabled]="loading()">
    <mat-icon matPrefix>search</mat-icon>
    @if (query()) {
      <button matSuffix
              mat-icon-button
              type="button"
              aria-label="Очистить"
              class="clear-btn"
              (click)="clearQuery()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  <div class="range-fields" [formGroup]="form">
    <app-datetime-input formControlName="start"
                        dateLabel="Дата начала"
                        timeLabel="Время"
                        [step]="300">
    </app-datetime-input>
    <app-datetime-input formControlName="end"
                        dateLabel="Дата окончания"
                        timeLabel="Время"
                        [step]="300">
    </app-datetime-input>
  </div>

  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (availableCars().length === 0) {
    <div class="empty-state">
      <mat-icon>directions_car</mat-icon>
      <p>Нет свободных автомобилей</p>
    </div>
  } @else {
    <div class="cars-grid">
      @for (item of filteredCars(); track item.car_id) {
        <app-car-card [car]="item" />
      } @empty {
        <div class="empty-state">
          <mat-icon>search_off</mat-icon>
          <p>По запросу «{{ trimmedQuery() }}» ничего не найдено</p>
        </div>
      }
    </div>
  }
</div>
